import { render, staticRenderFns } from "./categoriesTable.vue?vue&type=template&id=422c96ba&scoped=true&"
import script from "./categoriesTable.vue?vue&type=script&lang=js&"
export * from "./categoriesTable.vue?vue&type=script&lang=js&"
import style0 from "./categoriesTable.vue?vue&type=style&index=0&id=422c96ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422c96ba",
  null
  
)

export default component.exports